import React, { useState, useEffect } from 'react';
import Input from './ui/Input';
import Button from './ui/Button';
import Icon from './AppIcon';

const AdminSessionManager = ({ children, correctPassword = 'admin123' }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const sessionAuth = sessionStorage.getItem('adminAuthenticated');
    const sessionTime = sessionStorage.getItem('adminSessionTime');
    const currentTime = new Date()?.getTime();
    const sessionTimeout = 8 * 60 * 60 * 1000;

    if (sessionAuth === 'true' && sessionTime) {
      const timeDiff = currentTime - parseInt(sessionTime, 10);
      if (timeDiff < sessionTimeout) {
        setIsAuthenticated(true);
      } else {
        sessionStorage.removeItem('adminAuthenticated');
        sessionStorage.removeItem('adminSessionTime');
      }
    }
  }, []);

  const handleLogin = (e) => {
    e?.preventDefault();
    setError('');
    setIsLoading(true);

    setTimeout(() => {
      if (password === correctPassword) {
        const currentTime = new Date()?.getTime();
        sessionStorage.setItem('adminAuthenticated', 'true');
        sessionStorage.setItem('adminSessionTime', currentTime?.toString());
        setIsAuthenticated(true);
        setPassword('');
      } else {
        setError('Yanlış şifre. Lütfen tekrar deneyin.');
      }
      setIsLoading(false);
    }, 800);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('adminAuthenticated');
    sessionStorage.removeItem('adminSessionTime');
    setIsAuthenticated(false);
    setPassword('');
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="w-full max-w-md">
          <div className="card">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-primary/10 mb-4">
                <Icon name="Lock" size={32} color="var(--color-primary)" />
              </div>
              <h2 className="text-h3 font-heading font-semibold text-foreground mb-2">
                Admin Paneli
              </h2>
              <p className="caption text-muted-foreground">
                Devam etmek için şifrenizi girin
              </p>
            </div>

            <form onSubmit={handleLogin} className="space-y-6">
              <Input
                type="password"
                label="Şifre"
                placeholder="Admin şifresini girin"
                value={password}
                onChange={(e) => setPassword(e?.target?.value)}
                error={error}
                required
                disabled={isLoading}
              />

              <Button
                type="submit"
                variant="default"
                size="lg"
                fullWidth
                loading={isLoading}
                iconName="LogIn"
                iconPosition="right"
              >
                Giriş Yap
              </Button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="sticky top-0 z-sticky bg-card shadow-md">
        <div className="container-safe py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name="Shield" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h1 className="text-lg font-heading font-semibold text-foreground">
                Admin Paneli
              </h1>
              <p className="caption text-muted-foreground">
                İçerik Yönetimi
              </p>
            </div>
          </div>

          <Button
            variant="outline"
            size="default"
            onClick={handleLogout}
            iconName="LogOut"
            iconPosition="left"
          >
            Çıkış Yap
          </Button>
        </div>
      </div>

      <main className="container-safe py-8">
        {children}
      </main>
    </div>
  );
};

export default AdminSessionManager;